import * as yup from 'yup';

import i18n from 'i18n/config';
import { UnitsEnum } from 'modules/CreateNewRoomModal/AutoRemindersStepModal/utils';
import { getFullDateAt } from 'modules/CreateNewRoomModal/CreateRoomStepModal/utils';

import { getReminderSchema } from './getCreateNewRoom';
import { Schemas } from '../validationSchemas';

type remindersType = yup.InferType<ReturnType<typeof getReminderSchema>>[] | undefined;
type CreateNewRoomType = yup.InferType<ReturnType<typeof Schemas.getCreateNewRoom>>;

const START_LIMIT_MINS = 30;
const REMINDER_LIMIT_MINS = 15;
const START_LIMIT_MS = START_LIMIT_MINS * 60 * 1000;
const REMINDER_LIMIT_MS = REMINDER_LIMIT_MINS * 60 * 1000;

export const getRemindersValidationTest = () => ({
  name: 'reminders-validation',
  test(reminders: remindersType, { createError, parent }: yup.TestContext) {
    const { startDate, startTime, timeZone } = parent as CreateNewRoomType;
    if (!reminders?.length || !startDate || !startTime) return true;

    const fullDate = getFullDateAt(startDate, startTime, timeZone);
    const startsAt = new Date(fullDate);
    const dateNow = new Date();
    const validationErrors: yup.ValidationError[] = [];

    reminders.forEach(({ amount, unit, enabled, isCustom }, i) => {
      if (!amount || !enabled) return;

      const reminderDate = new Date(fullDate);
      if (unit === UnitsEnum.MINUTES) {
        reminderDate.setMinutes(reminderDate.getMinutes() - amount);
      } else if (unit === UnitsEnum.HOURS) {
        reminderDate.setHours(reminderDate.getHours() - amount);
      } else {
        reminderDate.setDate(reminderDate.getDate() - amount);
      }

      const path = `reminders[${i}].amount`;
      const timeUntilStartMs = startsAt.getTime() - dateNow.getTime();
      const timeUntilReminderMs = startsAt.getTime() - reminderDate.getTime();
      const hasLimitedReminders = timeUntilStartMs <= START_LIMIT_MS && timeUntilReminderMs > REMINDER_LIMIT_MS;
      const isReminderInPast = reminderDate <= dateNow;
      const hasSameReminder =
        reminders.filter(
          (reminder) => reminder.amount === amount && reminder.unit === unit && reminder.enabled && enabled
        ).length > 1;

      const pushError = (message: string) => validationErrors.push(createError({ path, message }));

      if (hasSameReminder) return pushError(i18n.t('duplicate_reminder'));
      if (isReminderInPast) return pushError(i18n.t('invalid_reminder'));
      if (hasLimitedReminders && isCustom) {
        return pushError(
          i18n.t('reminder_limit', { startLimit: START_LIMIT_MINS, reminderLimit: REMINDER_LIMIT_MINS })
        );
      }
    });

    if (validationErrors.length) throw new yup.ValidationError(validationErrors);

    return true;
  },
});
